/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { VendorJoinLogDto } from '../models/vendor-join-log-dto';
import { vendorWorkspaceJoinLogControllerAcceptJoinRequest } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-accept-join-request';
import { VendorWorkspaceJoinLogControllerAcceptJoinRequest$Params } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-accept-join-request';
import { vendorWorkspaceJoinLogControllerCancelJoinRequest } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-cancel-join-request';
import { VendorWorkspaceJoinLogControllerCancelJoinRequest$Params } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-cancel-join-request';
import { vendorWorkspaceJoinLogControllerJoinUser } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-join-user';
import { VendorWorkspaceJoinLogControllerJoinUser$Params } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-join-user';
import { vendorWorkspaceJoinLogControllerRejectJoinRequest } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-reject-join-request';
import { VendorWorkspaceJoinLogControllerRejectJoinRequest$Params } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-reject-join-request';
import { vendorWorkspaceJoinLogControllerSearchCursor } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-search-cursor';
import { VendorWorkspaceJoinLogControllerSearchCursor$Params } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-search-cursor';
import { vendorWorkspaceJoinLogControllerSearchOffset } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-search-offset';
import { VendorWorkspaceJoinLogControllerSearchOffset$Params } from '../fn/vendor-join-log/vendor-workspace-join-log-controller-search-offset';

@Injectable({ providedIn: 'root' })
export class VendorJoinLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorWorkspaceJoinLogControllerSearchOffset()` */
  static readonly VendorWorkspaceJoinLogControllerSearchOffsetPath = '/api/vendorJoinLog/join/search/offset';

  /**
   * 워크스페이스 가입 내역 오프셋 기반 검색.
   *
   * 워크스페이스 가입 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceJoinLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerSearchOffset$Response(params: VendorWorkspaceJoinLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorWorkspaceJoinLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 내역 오프셋 기반 검색.
   *
   * 워크스페이스 가입 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceJoinLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerSearchOffset(params: VendorWorkspaceJoinLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorWorkspaceJoinLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceJoinLogControllerSearchCursor()` */
  static readonly VendorWorkspaceJoinLogControllerSearchCursorPath = '/api/vendorJoinLog/join/search/cursor';

  /**
   * 워크스페이스 가입 내역 커서 기반 검색.
   *
   * 워크스페이스 가입 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceJoinLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerSearchCursor$Response(params: VendorWorkspaceJoinLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return vendorWorkspaceJoinLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 내역 커서 기반 검색.
   *
   * 워크스페이스 가입 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceJoinLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerSearchCursor(params: VendorWorkspaceJoinLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.vendorWorkspaceJoinLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceJoinLogControllerJoinUser()` */
  static readonly VendorWorkspaceJoinLogControllerJoinUserPath = '/api/vendorJoinLog/{id}/join';

  /**
   * 워크스페이스 가입 요청.
   *
   * 워크스페이스에 가입을 요청합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceJoinLogControllerJoinUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerJoinUser$Response(params: VendorWorkspaceJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorJoinLogDto>> {
    return vendorWorkspaceJoinLogControllerJoinUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 요청.
   *
   * 워크스페이스에 가입을 요청합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceJoinLogControllerJoinUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerJoinUser(params: VendorWorkspaceJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<VendorJoinLogDto> {
    return this.vendorWorkspaceJoinLogControllerJoinUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorJoinLogDto>): VendorJoinLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceJoinLogControllerAcceptJoinRequest()` */
  static readonly VendorWorkspaceJoinLogControllerAcceptJoinRequestPath = '/api/vendorJoinLog/{id}/join/{joinId}/accept';

  /**
   * 워크스페이스 가입 승인.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 승인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceJoinLogControllerAcceptJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerAcceptJoinRequest$Response(params: VendorWorkspaceJoinLogControllerAcceptJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorJoinLogDto>> {
    return vendorWorkspaceJoinLogControllerAcceptJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 승인.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 승인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceJoinLogControllerAcceptJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerAcceptJoinRequest(params: VendorWorkspaceJoinLogControllerAcceptJoinRequest$Params, context?: HttpContext): Observable<VendorJoinLogDto> {
    return this.vendorWorkspaceJoinLogControllerAcceptJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorJoinLogDto>): VendorJoinLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceJoinLogControllerRejectJoinRequest()` */
  static readonly VendorWorkspaceJoinLogControllerRejectJoinRequestPath = '/api/vendorJoinLog/{id}/join/{joinId}/reject';

  /**
   * 워크스페이스 가입 거부.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 거부합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceJoinLogControllerRejectJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerRejectJoinRequest$Response(params: VendorWorkspaceJoinLogControllerRejectJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorJoinLogDto>> {
    return vendorWorkspaceJoinLogControllerRejectJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 거부.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 거부합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceJoinLogControllerRejectJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerRejectJoinRequest(params: VendorWorkspaceJoinLogControllerRejectJoinRequest$Params, context?: HttpContext): Observable<VendorJoinLogDto> {
    return this.vendorWorkspaceJoinLogControllerRejectJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorJoinLogDto>): VendorJoinLogDto => r.body)
    );
  }

  /** Path part for operation `vendorWorkspaceJoinLogControllerCancelJoinRequest()` */
  static readonly VendorWorkspaceJoinLogControllerCancelJoinRequestPath = '/api/vendorJoinLog/join/{id}/cancel';

  /**
   * 가입 요청 취소.
   *
   * 가입 요청을 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorWorkspaceJoinLogControllerCancelJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerCancelJoinRequest$Response(params: VendorWorkspaceJoinLogControllerCancelJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorJoinLogDto>> {
    return vendorWorkspaceJoinLogControllerCancelJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 가입 요청 취소.
   *
   * 가입 요청을 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorWorkspaceJoinLogControllerCancelJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorWorkspaceJoinLogControllerCancelJoinRequest(params: VendorWorkspaceJoinLogControllerCancelJoinRequest$Params, context?: HttpContext): Observable<VendorJoinLogDto> {
    return this.vendorWorkspaceJoinLogControllerCancelJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorJoinLogDto>): VendorJoinLogDto => r.body)
    );
  }

}
